module.exports = __webpack_public_path__ + "static/45-46e07947b813040c00870cf9b9fefd3b.jpg";